import { render, staticRenderFns } from "./testsCenter.vue?vue&type=template&id=7294ba82&scoped=true"
import script from "./testsCenter.vue?vue&type=script&lang=js"
export * from "./testsCenter.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/lib/tests.scss?vue&type=style&index=0&id=7294ba82&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7294ba82",
  null
  
)

export default component.exports